module.exports = __webpack_public_path__ + "static/media/it.25c42bbf.svg";